var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel-directory',_vm._g(_vm._b({attrs:{"title":"Муниципалитет","action-type":_vm.actionType,"api-method":_vm.$rApi.directories.getMuns,"api-query":_vm.apiQuery,"input-attrs":_vm.inputAttrs,"refresh-key":_vm.regionId,"no-reset":""}},'panel-directory',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }